import { AfterViewInit, Component, OnInit } from '@angular/core';
import { DialogConfig } from 'src/modules/base/components/dialog/dialog-config';
import { DialogRef } from 'src/modules/base/components/dialog/dialog-ref';
import { SmartModalService } from 'src/modules/base/services/smart-modal.service';

@Component({
  selector: 'app-token-pop-up-view',
  templateUrl: './token-pop-up-view.component.html',
  styleUrls: ['./token-pop-up-view.component.scss'],
  standalone: false
})
export class TokenPopUpViewComponent implements OnInit, AfterViewInit {
  data: any; origin: any = location.origin;
  private ctx: AudioContext | null = null;
  constructor(
    private dialogConfig: DialogConfig,
    private dialogRef: DialogRef,
    private smartModalService: SmartModalService
  ) { }

  ngOnInit(): void {
    this.data = this.dialogConfig;
    setTimeout(() => {
      this.closepopup()
    }, 5000)

  }
  ngAfterViewInit() {
    if (this.data && !this.data.generateToken) {
      this.unlock();
      this.playLatchSound();
      // let call: any = document.getElementById("play_ringtone");
      // call.play().then(() => {
      // }).catch((error) => {
      //   console.error('Autoplay was prevented.', error);
      // });
    }
  }

  closepopup() {
    this.dialogRef.close()
  }

  close() {
    this.smartModalService.close(true);
    this.closepopup();
  }

  unlock() {
    this.ctx = new (window.AudioContext || (window as any).webkitAudioContext)();
  }

  playBeep() {
    if (!this.ctx) this.unlock();
    const ctx = this.ctx!;

    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);

    osc.frequency.value = 1500;
    osc.type = 'triangle';         // sharper harmonic edge than sine
    gain.gain.setValueAtTime(0.4, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.4);

    osc.start();
    osc.stop(ctx.currentTime + 0.4);
  }

  playLatchSound(): void {
    try {
      if (!this.ctx || this.ctx.state === 'closed') {
        this.ctx = new (window.AudioContext || (window as any).webkitAudioContext)();
      }
      const ctx = this.ctx;
      const now = ctx.currentTime;

      // 1. Short noise "click" for the mechanical transient
      const noiseBuffer = ctx.createBuffer(1, ctx.sampleRate * 0.03, ctx.sampleRate);
      const noiseData = noiseBuffer.getChannelData(0);
      for (let i = 0; i < noiseData.length; i++) {
        noiseData[i] = (Math.random() * 2 - 1) * (1 - i / noiseData.length);
      }
      const noiseSource = ctx.createBufferSource();
      noiseSource.buffer = noiseBuffer;

      const noiseFilter = ctx.createBiquadFilter();
      noiseFilter.type = 'highpass';
      noiseFilter.frequency.value = 2100;

      const noiseGain = ctx.createGain();
      noiseGain.gain.setValueAtTime(0.4, now);
      noiseGain.gain.exponentialRampToValueAtTime(0.001, now + 0.04);

      noiseSource.connect(noiseFilter);
      noiseFilter.connect(noiseGain);
      noiseGain.connect(ctx.destination);

      // 2. Two metallic tones (the "clunk" body of the latch)
      const tones = [
        { freq: 660, gain: 0.25 },
        { freq: 1050, gain: 0.3 }
      ];

      tones.forEach(({ freq, gain }) => {
        const osc = ctx.createOscillator();
        const oscGain = ctx.createGain();

        osc.type = 'triangle';
        osc.frequency.setValueAtTime(freq, now);
        osc.frequency.exponentialRampToValueAtTime(freq * 0.97, now + 1.2); // tiny pitch droop

        oscGain.gain.setValueAtTime(0, now);
        oscGain.gain.linearRampToValueAtTime(gain, now + 0.02);   // fast attack
        oscGain.gain.exponentialRampToValueAtTime(0.001, now + 1); // smooth decay

        osc.connect(oscGain);
        oscGain.connect(ctx.destination);

        osc.start(now);
        osc.stop(now + 1.3);
      });

      noiseSource.start(now);
      noiseSource.stop(now + 0.04);

    } catch (e) {
      console.warn('Could not play latch sound:', e);
    }
  }

}
